import { render, staticRenderFns } from "./flex-events.vue?vue&type=template&id=55123f4c&scoped=true&"
import script from "./flex-events.vue?vue&type=script&lang=js&"
export * from "./flex-events.vue?vue&type=script&lang=js&"
import style0 from "./flex-events.vue?vue&type=style&index=0&id=55123f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55123f4c",
  null
  
)

export default component.exports